const DIALOG_BOX_DELETE_RESOURCE = 'DIALOG_BOX_DELETE_RESOURCE';
const DIALOG_BOX_DELETE_RESOURCE_OK = 'DIALOG_BOX_DELETE_RESOURCE_OK';
const DIALOG_BOX_DELETE_RESOURCE_CANCEL = 'DIALOG_BOX_DELETE_RESOURCE_CANCEL';
const DIALOG_BOX_DELETE_RESOURCE_SUCCESS = 'DIALOG_BOX_DELETE_RESOURCE_SUCCESS';
const DIALOG_BOX_DELETE_RESOURCE_ERROR = 'DIALOG_BOX_DELETE_RESOURCE_ERROR';
const DIALOG_BOX_DELETE_RESOURCE_CLOSE = 'DIALOG_BOX_DELETE_RESOURCE_CLOSE';

const VALIDATE_ACTION = 'validate-action';
const CANCEL_ACTION = 'cancel-action';

export default {
	DIALOG_BOX_DELETE_RESOURCE,
	DIALOG_BOX_DELETE_RESOURCE_OK,
	DIALOG_BOX_DELETE_RESOURCE_CANCEL,
	DIALOG_BOX_DELETE_RESOURCE_SUCCESS,
	DIALOG_BOX_DELETE_RESOURCE_ERROR,
	DIALOG_BOX_DELETE_RESOURCE_CLOSE,
	VALIDATE_ACTION,
	CANCEL_ACTION,
};
